// Word Wheel puzzles for French.
// letters: the seven tiles. words: common words to find (shown in the count). extra: other valid words, accepted as bonus.
// Checked against a spelling dictionary, so no word needs to be verified while playing.

export const WHEEL_FR = [
    {
        letters: 'unuirma',
        words: 'air ira mai main manu mari marin min muni mur unir uranium',
        extra: 'arum mina mira mua munir mura mûri nia nui nuira rai rami ria rima rua ruina unira',
    },
    {
        letters: 'obloust',
        words: 'boulot boulots bout bouts bus buts loto lotus obus sol solo tous',
        extra: 'bol bols bot bous bulot lob lotos lus lut obtus ost oust sot sou soûl sut tus',
    },
    {
        letters: 'ntseomr',
        words: 'mer mes met mets mon monstre monter montre montres mort morts mot mots nom noms nos note notes notre ont rose seront sert son sont sort sorte tes ton très',
        extra: 'mens ment mers mont monte monts montés morne mornes mors morte mortes msr métro métros nem nems net nets nome nomes norme normes noter néo nés nôtres omet ores orme ormes orné ornés ors ose osent oser ost rem renom resto rets rote sermon sot sténo tome tomer tomes tores tors torse trône trônes ténor ténors éon étron ôte ôter',
    },
    {
        letters: 'omtatse',
        words: 'atome atomes matos mes met mets mot mots motte ose tas tes tomate tomates tome tomes âmes état états',
        extra: 'mas maso mat mattes maté motet motets motta mottes mâts méta omet osa ost sema sot sotte testa toma tomas totem totems tâte têt ôta ôte',
    },
    {
        letters: 'ebcruea',
        words: 'arc aube bac beau berceau car crabe cru crue créa créé cuba cube curé eau reçu reçue ère',
        extra: 'aber acerbe acéré aéré bau bec ber bercé beur bru bue bure buée béa bée cabre cré cura curée rab racé racée rebeu rua ruée réa réac rée urée âcre écru écu',
    },
    {
        letters: 'tocnera',
        words: 'acte arc art car carte carton cent cet conte contre coran crâne créant côté net note noter notre néo océan ont raconte raté ton trace trône écart écran',
        extra: 'acné acter actéon ancre antre aorte arçon atroce canot canoë carne carnet caron caté conta conter cor corne cornet cota coter cotre cran croate cré créa cône encart encor entra nacre narco nec nectar noce nocera nota notera nécro ocre orné racé rance rat raton recto renta roc ronce rota rote réa réac tac tance taro taré tec trac troc tronc ténor âcre âne âtre écot éon étron ôta ôte ôter ôtera',
    },
    {
        letters: 'sauxicf',
        words: 'aux cas fac fais faux fisc fiscaux fuis sac sauf six usa',
        extra: 'ais cuis facs fax fia fias ficus fis fixa fui fus saï sua suc sui suif',
    },
    {
        letters: 'neeptir',
        words: 'entier entre inter net nier née peine peint peintre pente perte pire prie prit pré prêt prête père reine rené rien tenir tien tir tire ère été être',
        extra: 'ente inepte inerte ire nie niée peiner peinte pinte pinter pitre piètre piété prient priée pète péri périt péter pétri pétrie pétrin pêne rein renie rente repeint repenti rie rient rit rite rée répit rétine tep terne terni ternie tine tirée tri trie trin trine triée épi épie épier épine épître étire',
    },
    {
        letters: 'mseeont',
        words: 'mes met mets mon mont monte montée montées mot mots mène météo net nom noms nos note notes née néo ont ose son sont tes tome ton été êtes',
        extra: 'ente este mens mense ment mente menés monts montés météos nem nems nets nome nomes notée notées nées nés omet osent ost osée semé sente sot sténo sèment séné tomes émet émets éon ôte ôtée',
    },
    {
        letters: 'aiettrr',
        words: 'air aire ait arrêt art atterri attire attirer ira rare rater raté retrait rire rite taire tait tarte taré tir tire tirer titre trait traiter traité traître était état',
        extra: 'aie erra errait ire rai raie rait rat ratier ratte retira ria rie rira rit réa taie tari tarie tarir tarit tartre tatie terra tiare tira tirera tiret titrer traire tri tria trie trier tâte tâter têt âtre étai étira',
    },
    {
        letters: 'aefnrri',
        words: 'afin air aire aîné faire farine fer fera ferai fier fin frein ira naïf nerf nier raie rare refrain rein rien rire',
        extra: 'aie arien erra fane faner ferra ferrai fia fie fiera frai fraie frire férir infra ire narre nef nia nie niera rai raine rainer ria rie rira réa réf âne',
    },
    {
        letters: 'oriatcc',
        words: 'accro accroît air ait arc art car ciao coca croit ira roi tir toi trio',
        extra: 'cari circ cit cita coi cor cota coït crac cri cria cric croc iota oit rai rait rat ria rit roc rota rôti tac tari taro tic tira trac tri tria tric troc ôta',
    },
];